var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVanDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_441_1706)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99997 10C12.7575 10 15 7.7575 15 5C15 2.2425 12.7575 0 9.99997 0C7.24247 0 4.99997 2.2425 4.99997 5C4.99997 7.7575 7.24247 10 9.99997 10ZM9.99997 1.66667C11.8383 1.66667 13.3333 3.16167 13.3333 5C13.3333 6.83833 11.8383 8.33333 9.99997 8.33333C8.16164 8.33333 6.66664 6.83833 6.66664 5C6.66664 3.16167 8.16164 1.66667 9.99997 1.66667ZM18.28 19.075C18.3308 19.5325 18.0266 20 17.45 20C17.0308 20 16.67 19.685 16.6225 19.2583C16.2491 15.8808 13.4016 13.3333 9.99997 13.3333C6.5983 13.3333 3.7508 15.8808 3.37747 19.2583C3.32664 19.7158 2.91164 20.0475 2.45747 19.995C1.99997 19.9442 1.66997 19.5325 1.7208 19.075C2.1883 14.8517 5.7483 11.6667 10.0008 11.6667C14.2533 11.6667 17.8125 14.8517 18.28 19.075ZM14.9 19.0008C14.9916 19.4525 14.7 19.8917 14.2491 19.9833C14.1933 19.995 14.1375 20 14.0825 20C13.6941 20 13.3466 19.7275 13.2666 19.3325C12.9533 17.7875 11.5791 16.6667 10.0008 16.6667C8.42247 16.6667 7.0483 17.7875 6.73497 19.3325C6.6433 19.7833 6.20664 20.0767 5.75247 19.9833C5.30164 19.8917 5.00997 19.4517 5.10164 19.0008C5.57247 16.6825 7.6333 15 10.0008 15C12.3683 15 14.4291 16.6825 14.9 19.0008Z",
    fill: "#98A1B2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_441_1706"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVanDriver);
export default __webpack_public_path__ + "static/media/vanDriver.78f9992ec79ff7ea0341b326cd90018e.svg";
export { ForwardRef as ReactComponent };